import { render, staticRenderFns } from "./system_customers.vue?vue&type=template&id=dce3d9cc&scoped=true&"
import script from "./system_customers.vue?vue&type=script&lang=js&"
export * from "./system_customers.vue?vue&type=script&lang=js&"
import style0 from "./system_customers.vue?vue&type=style&index=0&id=dce3d9cc&prod&lang=css&"
import style1 from "./system_customers.vue?vue&type=style&index=1&id=dce3d9cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce3d9cc",
  null
  
)

export default component.exports